<template>
  <div class="feedback">
    <div class="toolbar">
      <a-space>
        <a-button type="primary" @click="handleUpdateFeedback(null)"
          >新增反馈意见</a-button
        >
      </a-space>
    </div>

    <div class="feedback-table" ref="scrollBox">
      <a-table
        bordered
        :dataSource="tableData"
        :columns="columns"
        rowKey="id"
        :pagination="false"
        :scroll="{ x: tableSroll.x, y: tableSroll.y }"
      >
        <template #action="{ record }">
          <a-button
            size="small"
            @click="handleUpdateFeedback(record)"
            v-if="record.userId == store.state.user.user.id"
            >编辑</a-button
          >
        </template>
      </a-table>
    </div>

    <div class="pagination df both-side">
      <a-pagination
        v-model:current="requestPayload.pageNum"
        v-model:pageSize="requestPayload.lineNum"
        :total="requestPayload.total"
        :show-total="(total) => `共 ${total} 条`"
        @change="handlePageChange"
        @showSizeChange="handleSizeChange"
        size="small"
      />
    </div>
  </div>

  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-textarea
      v-model:value="feedback"
      auto-size
      placeholder="请输入反馈意见"
    />
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref, nextTick, onMounted } from "vue";
import {
  getFeedbackList,
  saveOrUpdateFeedback,
} from "@/request/view/qualityInspection";
import { useStore } from "vuex";
import { Toast } from "@/utils";

export default defineComponent({
  props: {
    feedbackType: String,
  },
  setup(props, context) {
    const store = useStore();
    const requestPayload = reactive({
      lineNum: 10,
      pageNum: 1,
      total: 0,
    });

    const tableData = reactive([]);

    const columns = reactive([
      { title: "序号", dataIndex: "id", width: 80, align: "center" },
      { title: "意见反馈", dataIndex: "feedback", width: 80, align: "center" },
      { title: "用户", dataIndex: "username", width: 80, align: "center" },
      { title: "时间", dataIndex: "createTime", width: 80, align: "center" },
      {
        title: "操作",
        slots: { customRender: "action" },
        width: 80,
        align: "center",
      },
    ]);

    const modalConfig = reactive({
      title: "意见反馈",
      visible: false,
    });

    const feedback = ref(null);
    let echoId = null;

    const handleUpdateFeedback = (data) => {
      if (!data) {
        modalConfig.visible = true;
        feedback.value = null;
      } else {
        modalConfig.visible = true;
        feedback.value = data.feedback;
        echoId = data.id;
      }
    };

    const handleCancel = () => {
      modalConfig.visible = false;
      feedback.value = null;
      echoId = null;
    };

    const getTableData = () => {
      tableData.length = 0;
      getFeedbackList({
        lineNum: requestPayload.lineNum,
        pageNum: requestPayload.pageNum,
        type: props.feedbackType,
      })
        .then((res) => {
          if (res.code === 200 && res.message === "成功") {
            tableData.push(...res.data.records);
            requestPayload.total = res.data.total;
            getTableScroll();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const handleOk = () => {
      const { id, username } = store.state.user.user;
      saveOrUpdateFeedback({
        type: props.feedbackType,
        feedback: feedback.value,
        userId: id,
        username,
        id: echoId,
      })
        .then((res) => {
          let type = res.code === 200 ? "success" : "warning";
          Toast(type, res.message, 3);
          handleCancel();
          getTableData();
        })
        .catch((err) => {});
    };

    const handlePageChange = (page) => {
      requestPayload.pageNum = page;
      getTableData();
    };

    const scrollBox = ref();
    const tableSroll = reactive({
      x: null,
      y: null,
    });

    const getTableScroll = () => {
      nextTick(() => {
        if (scrollBox.value) {
          const domInfo = scrollBox.value.getBoundingClientRect();
          tableSroll.y = domInfo.height - 100;
        }
      });
    };

    window.addEventListener("resize", getTableScroll);

    const handleSizeChange = (page, pageSize) => {
      console.log(page, pageSize);
    };

    getTableData();
    return {
      store,
      requestPayload,
      tableData,
      columns,
      modalConfig,
      feedback,
      handleUpdateFeedback,
      handleOk,
      handleCancel,
      handlePageChange,
      scrollBox,
      tableSroll,
      handleSizeChange,
    };
  },
});
</script>

<style lang="less" scoped>
.feedback {
  .toolbar {
    margin-bottom: 10px;
  }
  .feedback-table {
    height: calc(100vh - 260px);
  }
}
</style>
